module.exports = __webpack_public_path__ + "img/lock.be5cf871.png";